"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function MetaformTableColumnValuesFromJSON(json) {
    return MetaformTableColumnValuesFromJSONTyped(json, false);
}
exports.MetaformTableColumnValuesFromJSON = MetaformTableColumnValuesFromJSON;
function MetaformTableColumnValuesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': !runtime_1.exists(json, 'value') ? undefined : json['value'],
        'other': !runtime_1.exists(json, 'other') ? undefined : json['other'],
        'text': !runtime_1.exists(json, 'text') ? undefined : json['text'],
    };
}
exports.MetaformTableColumnValuesFromJSONTyped = MetaformTableColumnValuesFromJSONTyped;
function MetaformTableColumnValuesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'other': value.other,
        'text': value.text,
    };
}
exports.MetaformTableColumnValuesToJSON = MetaformTableColumnValuesToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1UYWJsZUNvbHVtblZhbHVlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9nZW5lcmF0ZWQvY2xpZW50L21vZGVscy9NZXRhZm9ybVRhYmxlQ29sdW1uVmFsdWVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxvQkFBb0I7QUFDcEIsb0JBQW9CO0FBQ3BCOzs7Ozs7Ozs7O0dBVUc7O0FBRUgsd0NBQStDO0FBMkIvQyxTQUFnQixpQ0FBaUMsQ0FBQyxJQUFTO0lBQ3ZELE9BQU8sc0NBQXNDLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQy9ELENBQUM7QUFGRCw4RUFFQztBQUVELFNBQWdCLHNDQUFzQyxDQUFDLElBQVMsRUFBRSxtQkFBNEI7SUFDMUYsSUFBSSxDQUFDLElBQUksS0FBSyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsRUFBRTtRQUN6QyxPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILE9BQU8sRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUM7UUFDM0QsT0FBTyxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQztRQUMzRCxNQUFNLEVBQUUsQ0FBQyxnQkFBTSxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO0tBQzNELENBQUM7QUFDTixDQUFDO0FBVkQsd0ZBVUM7QUFFRCxTQUFnQiwrQkFBK0IsQ0FBQyxLQUF3QztJQUNwRixJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7UUFDckIsT0FBTyxTQUFTLENBQUM7S0FDcEI7SUFDRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDaEIsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxPQUFPLEVBQUUsS0FBSyxDQUFDLEtBQUs7UUFDcEIsT0FBTyxFQUFFLEtBQUssQ0FBQyxLQUFLO1FBQ3BCLE1BQU0sRUFBRSxLQUFLLENBQUMsSUFBSTtLQUNyQixDQUFDO0FBQ04sQ0FBQztBQWJELDBFQWFDIn0=